import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

export function useValidationSchema(memberAccount) {
    const intl = useIntl()

    const validationSchema = useMemo(() => {
        if (memberAccount) {
            return Yup.object({
                firstName: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
                lastName: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
                phone: Yup.string()
                    .matches(
                        /^[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
                        intl.formatMessage({ id: 'forms.register.phoneError' })
                    )
                    .required(intl.formatMessage({ id: 'forms.required' })),
                email: Yup.string()
                    .email(intl.formatMessage({ id: 'forms.register.emailError' }))
                    .required(intl.formatMessage({ id: 'forms.required' })),

                password: Yup.string()
                    .required(intl.formatMessage({ id: 'forms.required' }))
                    .test(
                        'password does not match email',
                        intl.formatMessage({ id: 'forms.register.passwordMatchesEmail' }),
                        function (value) {
                            return this.parent?.email !== value
                        }
                    ),
                controlPassword: Yup.string()
                    .required(intl.formatMessage({ id: 'forms.required' }))
                    .test(
                        'newPasswords-match',
                        intl.formatMessage({ id: 'forms.register.passwordsMustMatch' }),
                        function (value) {
                            return this.parent?.password === value
                        }
                    ),
                checkBoxTermsAndConditions: Yup.boolean().oneOf(
                    [true],
                    intl.formatMessage({ id: 'forms.register.checkBoxNotChecked' })
                ),
                gender: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
                date: Yup.date().required(intl.formatMessage({ id: 'forms.required' })),
                residance: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
                postalCode: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
                checkBoxMember: Yup.boolean().oneOf(
                    [true, false],
                    intl.formatMessage({ id: 'forms.register.checkBoxNotChecked' })
                ),
                checkBoxRead: Yup.boolean().oneOf(
                    [true],
                    intl.formatMessage({ id: 'forms.register.checkBoxNotChecked' })
                ),
            })
        }

        return Yup.object({
            firstName: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
            lastName: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
            phone: Yup.string()
                .matches(/^[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/, intl.formatMessage({ id: 'forms.register.phoneError' }))
                .required(intl.formatMessage({ id: 'forms.required' })),
            email: Yup.string()
                .email(intl.formatMessage({ id: 'forms.register.emailError' }))
                .required(intl.formatMessage({ id: 'forms.required' })),
            password: Yup.string()
                .required(intl.formatMessage({ id: 'forms.required' }))
                .test(
                    'password does not match email',
                    intl.formatMessage({ id: 'forms.register.passwordMatchesEmail' }),
                    function (value) {
                        return this.parent?.email !== value
                    }
                ),
            controlPassword: Yup.string()
                .required(intl.formatMessage({ id: 'forms.required' }))
                .test(
                    'newPasswords-match',
                    intl.formatMessage({ id: 'forms.register.passwordsMustMatch' }),
                    function (value) {
                        return this.parent?.password === value
                    }
                ),
            checkBoxTermsAndConditions: Yup.boolean().oneOf(
                [true],
                intl.formatMessage({ id: 'forms.register.checkBoxNotChecked' })
            ),
        })
    }, [memberAccount, intl])

    return validationSchema
}
